/**
 * sophia-fittext.js
 * Scales .artwork-hero__name and .pf-name (text variant only; the SVG logo variant scales itself) to fill their container width exactly.
 * Uses a single measurement pass (O(1)) — no binary search needed.
 */
(function () {
  'use strict';

  /**
   * Resize a single element to fill its parent's width.
   * @param {HTMLElement} el
   */
  function fitText(el) {
    if (!el || !el.parentElement) return;

    // Force single line so scrollWidth = full text width
    el.style.whiteSpace = 'nowrap';

    // Set a known reference size, then measure the text at that size
    var REF = 100;
    el.style.fontSize = REF + 'px';

    var textWidth      = el.scrollWidth;
    var containerWidth = el.parentElement.clientWidth;

    if (textWidth === 0 || containerWidth === 0) return;

    // Scale: if text is W px wide at 100px, it will be containerWidth px wide at:
    //   fontSize = 100 * (containerWidth / textWidth)
    // Subtract 1 px safety margin to avoid sub-pixel overflow triggering scroll.
    var fitted = REF * (containerWidth - 1) / textWidth;

    // Round down to two decimal places
    el.style.fontSize = Math.floor(fitted * 100) / 100 + 'px';
  }

  function fitAll() {
    document.querySelectorAll('.artwork-hero__name, .pf-name:not(.pf-name--logo)').forEach(fitText);
  }

  // ── Wait for web fonts before the first measurement ──────────
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAll);
  } else {
    window.addEventListener('load', fitAll);
  }

  // ── Re-measure on resize (debounced 40 ms) ────────────────────
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 40);
  });
})();
